import { Injectable, Injector, ApplicationRef, ComponentRef, EnvironmentInjector, Type } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class DialogProviderService {
  private overlayRef?: OverlayRef;

  constructor(
    private overlay: Overlay,
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) {}

  open<T>(
    component: Type<T>,
    inputs?: Partial<T>
  ): ComponentRef<T> {
    // Close existing overlay if any
    this.close();

    // Create the overlay
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
      panelClass: 'dialog-panel',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });

    // Handle backdrop click
    this.overlayRef.backdropClick().subscribe(() => this.close());

    // Create a portal for the component
    const portal = new ComponentPortal(component, null, this.injector);

    // Attach to overlay
    const componentRef = this.overlayRef.attach(portal);

    // Pass inputs if any
    if (inputs) {
      Object.assign(componentRef.instance as any, inputs);
    }

    return componentRef;
  }

  close() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
  }
}
